import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import './styles.scss';
import ParticipantTable from '../ParticipantTable';
import SecurityInformation from '../SecurityInformation';
import Products from '../Products';
import ProductDescription from '../ProductDescription';

export default function RegisterContent({
  control,
  errors,
  handleDownloadFile,
  disabled,
  viewOnly,
  registerResult,
  participants,
  onSubmit,
  registerResultId,
  refetch,
  isLiquidation,
}) {
  const { t } = useTranslation();
  return (
    <div className="report-form-container">
      <h4 className="font-bold">{t('r09.form.b')}</h4>
      <div className="my-2">
        <h4 className="my-2">{t('r09.form.b1')}</h4>
        <ParticipantTable
          disabled={disabled}
          control={control}
          errors={errors}
          participants={participants}
        />
      </div>
      {!isLiquidation && (
        <>
          <div>
            <h4>{t('r09.form.b2')}</h4>
            <SecurityInformation
              disabled={disabled}
              control={control}
              errors={errors}
              viewOnly={viewOnly}
              value={registerResult?.securitySeverity}
            />
          </div>
          <div>
            <h4>{t('r09.form.b3')}</h4>
            <Products
              disabled={disabled}
              control={control}
              errors={errors}
              data={registerResult?.statistics || {}}
            />
          </div>
          <h4>{t('r09.form.b4')}</h4>
          <ProductDescription
            disabled={disabled}
            control={control}
            errors={errors}
            onSubmit={onSubmit}
            registerResultId={registerResultId}
            refetch={refetch}
            handleDownloadFile={handleDownloadFile}
          />
        </>
      )}
    </div>
  );
}

RegisterContent.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleDownloadFile: PropTypes.func,
  disabled: PropTypes.bool,
  viewOnly: PropTypes.bool,
  registerResult: PropTypes.shape({
    securitySeverity: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    statistics: PropTypes.object,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  participants: PropTypes.arrayOf(PropTypes.shape({})),
  onSubmit: PropTypes.func,
  registerResultId: PropTypes.string,
  refetch: PropTypes.func,
  isLiquidation: PropTypes.bool,
};

RegisterContent.defaultProps = {
  handleDownloadFile: () => null,
  disabled: false,
  viewOnly: false,
  registerResult: {},
  participants: [],
  onSubmit: () => null,
  registerResultId: null,
  refetch: () => null,
  isLiquidation: false,
};
